import { Typography } from '@mui/material';
import React from 'react';
import parse from 'url-parse';

export const UrlInfo = props => {
  const url = parse(props.url);
  const filename = decodeURIComponent(url.pathname).split('/').slice(-1)[0];
  return <Typography variant="caption">{filename}</Typography>;
};
